import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import StandardsListItem from './StandardsListItem';

const Wrapper = styled.div`
  list-style: none;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #4FADA6;
  padding: 10px 0 15px;
`;

const NoResults = styled.div`
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  color: #031C38;
`;
const Standards = styled.ol`

`;

const StandardsList = ({data, performaceOpt}) => {
  const [standards, setStandards] = useState(data.standardData);

  useEffect(() => {
    setStandards(data.standardData);
  }, [data]);
  
  useEffect(() => {
    if (performaceOpt === 'all' || performaceOpt === '') {
      setStandards(data.standardData);
      return;
    }
    const filteredStandards = data.standardData.filter(st => {
      return st.standard.performanceClassification === performaceOpt;
    });
    setStandards(filteredStandards);
    
  }, [performaceOpt, data]);

  function replaceStrings (input: string): string {
    switch (input) {
      case 'food':
        return 'Food Quality';
      case 'employeeBehavioural':
        return 'EI Behavioral';
      default:
        return input.replace(/([A-Z])/g, ' $1');
    }
  }

  return (
    <Wrapper>
      <Title>{data.value}</Title>
      <Standards>
        {
          standards.length === 0 ? <NoResults>No Results</NoResults> : null
        }
        {standards.map((obj, idx) => {
          const standard = obj.standard;
          const standardClassification = standard && standard.performanceClassification && replaceStrings(standard.performanceClassification);
          const translationData = standard.translations.find(translation => translation.language === 'en').value;
          return (<StandardsListItem key={obj.id} classification={standardClassification} standardText={translationData} index={idx + 1} />);
        })}
      </Standards>
    </Wrapper>
  );
};

export default StandardsList;
